import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { formatDate1122 } from "../../../../CloudStorage/CommonFunction";

const Years = ({ setFirstdate, setLastdate, start_date, end_date }) => {
    const [startDate, setStartDate] = useState(start_date ? new Date(start_date) : null);
    const [endDate, setEndDate] = useState(end_date ? new Date(end_date) : null);

    const handleDatesSet = (arg) => {
        // Always start on Jan 1 of the given start year
        const baseStart = new Date(arg.start);
        const firstDate = new Date(baseStart.getFullYear(), 0, 1); // Jan 1

        // Always end 7 years later, Dec 31 of the last year
        const lastDate = new Date(firstDate.getFullYear() + 6, 11, 31); // Dec 31 of +6th year (total 7 years span)

        // Update parent state if provided
        if (setFirstdate) setFirstdate(formatDate1122(firstDate));
        if (setLastdate) setLastdate(formatDate1122(lastDate));

        setStartDate(firstDate);
        setEndDate(lastDate);
    };

    // Format the title like "2024 - 2030"
    const getFormattedTitle = () => {
        if (!startDate || !endDate) return "";
        const startYear = startDate.getFullYear();
        const endYear = endDate.getFullYear();
        return `${startYear} - ${endYear}`;
    };

    return (
        <div style={{ position: "relative" }}>
            <FullCalendar
                plugins={[dayGridPlugin]}
                initialView="dayGridYear"
                headerToolbar={{
                    left: "prev",
                    center: "customTitle",
                    right: "next",
                }}
                events={[]}
                datesSet={handleDatesSet}
                customButtons={{
                    customTitle: {
                        text: getFormattedTitle(),
                    },
                }}
                headerContent={() => (
                    <h2 style={{ margin: 0 }}>{getFormattedTitle()}</h2>
                )}
                dayRender={(info) => {
                    info.el.style.display = "none";
                }}
                eventDidMount={(info) => {
                    info.el.style.display = "none";
                }}
            />
            <style>
                {`
                    .fc-view {
                        display: none; 
                    }
                `}
            </style>
        </div>
    );
};

export default Years;
